import { render } from "./BranchDialog.vue?vue&type=template&id=bb04c620&scoped=true&ts=true"
import script from "./BranchDialog.vue?vue&type=script&lang=ts"
export * from "./BranchDialog.vue?vue&type=script&lang=ts"

import "./BranchDialog.vue?vue&type=style&index=0&id=bb04c620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb04c620"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QSeparator,QInput,QInnerLoading,QSpinner});
